// import Turntable_haiou from './haiou'
// import Turntable_xiniu from './xiniu'
//
// const Turntable = process.env['REACT_APP_CHANNEL'] === 'haiou' ? Turntable_haiou : Turntable_xiniu
// export default Turntable
import Turntable_xiniu from './xiniu'
import Turntable_qx from './type_qx'

let Turntable

switch (process.env['REACT_APP_CHANNEL']) {
  // todo channel
  // case 'ytyg':
  // case 'dyyg':
  //   break
  case 'qxtj':
  case 'qxyg':
  case 'qxdg':
  case 'tjyg':
    Turntable = Turntable_qx
    break
  case 'youpin':
  case 'xiniu':
  case 'xbyg':
  case 'xibei':
  case 'wanshun':
  default:
    Turntable = Turntable_xiniu
}

export default Turntable
